// Numeric access codes use a technical Auth identifier; users do not need a mailbox.
const codePattern=/^[0-9]{3,12}$/;
export function loginIdentifier(value){
 const input=String(value??'').trim();
 if(codePattern.test(input))return input+'@piloto.invalid';
 if(input.length<=254&&/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input))return input.toLowerCase();
 throw Error('Introduce tu código numérico o el correo de tu cuenta del piloto.');
}
export function accessLabel(email){
 const match=String(email||'').match(/^([0-9]{3,12})@piloto\.invalid$/i);
 return match?match[1]:String(email||'');
}
